module.exports = __webpack_public_path__ + "static/media/pet-year-final.007471b0.svg";